module.exports = __webpack_public_path__ + "static/media/Privacy_Policy - VFSC.56710afb.pdf";